import dynamic from 'next/dynamic';

import useMediaQuery from 'hooks/useMediaQuery';

const Sidebar = dynamic(() => import('./Sidebar'), {
  ssr: false,
});

const OfferSidebar = (props) => {
  const { isLg } = useMediaQuery();

  if (!isLg) {
    return null;
  }

  return <Sidebar {...props} />;
};

export default OfferSidebar;
